import { ads } from "lincd-ads/lib/ontologies/ads";
import { Account } from "lincd-ads/lib/shapes/Account";
import { dcelems } from "lincd-dcmi/lib/ontologies/dc";
import { PropertyMapping } from "lincd-rest-api/lib/shapes/PropertyMapping";

const mapper: PropertyMapping<Account> = new PropertyMapping(Account, {
    shapeParams: [["accountId"]],
    URI: "https://quora.api.lincd.org/",
});

/** Additional available properties
conversions
conversionRate
leadsGenerated
formCompletionRate
costPerLead
 */
mapper.map(ads.accountCurrency, ["accountCurrency"]);
mapper.map(ads.clicks, ["clicks"]);
mapper.map(ads.cpc, ["cpc"]);
mapper.map(ads.ctr, ["ctr"]);
mapper.map(ads.impressions, ["impressions"]);
mapper.map(ads.spend, ["spend"]);
mapper.map(dcelems.identifier, ["accountId"]);
mapper.map(dcelems.title, ["accountName"]);

export default mapper;
